import { render } from "./AuthorRegistrationForm.vue?vue&type=template&id=6e6d10f3&scoped=true"
import script from "./AuthorRegistrationForm.vue?vue&type=script&lang=js"
export * from "./AuthorRegistrationForm.vue?vue&type=script&lang=js"

import "./AuthorRegistrationForm.vue?vue&type=style&index=0&id=6e6d10f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6d10f3"]])

export default __exports__